import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/purchase-invoice-reports/:purchaseInvoiceId/export-pdf`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportSinglePDF = {
  post: apiPathFunc(pathBase),
};
